// extracted by mini-css-extract-plugin
export default {"playIcon":"playIcon--QB7qe","l":"l--JJmFN","m":"m--D4NJx","sm":"sm--vABpL","blink":"blink--NRj4v"};